import React, { useState, useEffect } from 'react';
import WilayaDropdown from '@/components/WilayaDropdown';
import StatusDropdown from './StatusDropdown';
import CollectorDropDown from '@/components/CollectorDropDown';
import { DateRangePicker } from '@/components/DateRangePicker';
import { DateRange } from 'react-day-picker';

type FiltersProps = {
  onFiltersChange: (filters: {
    selectedWilaya: string;
    status: string;
    selectedCollector: string;
    dateRange: DateRange | undefined; // Add dateRange to the filters
  }) => void;
};

const Filters: React.FC<FiltersProps> = ({ onFiltersChange }) => {
  const [selectedWilaya, setSelectedWilaya] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const [collector, setCollector] = useState<Employee>();
  const [selectedCollector, setSelectedCollector] = useState<string>('');
  const [dateRange, setDateRange] = useState<DateRange | undefined>(undefined); // Add state for the date range

  // Call onFiltersChange when any filter values change
  useEffect(() => {
    onFiltersChange({
      selectedWilaya,
      status,
      selectedCollector,
      dateRange, // Include dateRange in the filter change
    });
  }, [selectedWilaya, status, selectedCollector, dateRange]); // Include dateRange in the dependency array

  return (
    <div className='flex items-center'>
      <div>
        <WilayaDropdown
          isFilter={true}
          value={selectedWilaya}
          onValueChange={(value) =>
            setSelectedWilaya(value === 'all' ? '' : value)
          }
        />
      </div>

      <div>
        <StatusDropdown
          value={status}
          onValueChange={(value) => setStatus(value === 'all' ? '' : value)}
        />
      </div>

      <div>
        <CollectorDropDown
          isFilter
          value={collector?.fullname || ''}
          collector={collector}
          onValueChange={(value: string) => {
            const parsedObject = value === 'all' ? 'all' : JSON.parse(value);
            setCollector(parsedObject === 'all' ? '' : parsedObject);
            setSelectedCollector(parsedObject === 'all' ? '' : parsedObject.id);
          }}
        />
      </div>

      <div>
        <DateRangePicker date={dateRange} onDateChange={setDateRange} />
      </div>
    </div>
  );
};

export default Filters;
